import * as React from 'react';
import LinkPreviewFull from './components/LinkPreviewFull';
import isLinkPreviewOptionDirty from './utils/isLinkPreviewOptionDirty';
import discardLinkPreviewOption from './actions/discardLinkPreviewOption';
import saveLinkPreviewOption from './actions/saveLinkPreviewOption';
var LinkPreviewOption = {
    key: 'linkPreview',
    titleStringKey: 'optionTitle_linkPreview',
    searchTermsStringKey: 'optionTitle_linkPreview',
    fullOptionFormSettings: {
        render: function () { return React.createElement(LinkPreviewFull, null); },
        isDirty: isLinkPreviewOptionDirty,
        onSave: saveLinkPreviewOption,
        onDiscard: discardLinkPreviewOption,
    },
};
export default LinkPreviewOption;
//# sourceMappingURL=LinkPreviewOption.js.map